import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import translate from '@i18n'
import useBlickPlusSkeleton from '@hooks/useBlickPlusSkeleton'

interface TitleProps {
  availableShares?: number
  updatedAvailableShares?: number
}

const StyledTitle = styled.div`
  ${({
    theme: {
      typography: {
        headings: {
          xxsmall: { bundledCSS: xxsmallHeadingsCSS },
        },
      },
      colors: { textDefault },
    },
  }) => css`
    ${xxsmallHeadingsCSS};
    color: ${textDefault};
    align-self: flex-start;
    max-width: calc(100% - 34px);
  `}
`

const Title: FunctionComponent<TitleProps> = ({
  availableShares,
  updatedAvailableShares,
}) => {
  const { plusSharingLinkGenerationAmount } = useBlickPlusSkeleton()
  return (
    <StyledTitle>
      {typeof availableShares === 'number' && (
        <span>
          {updatedAvailableShares ?? availableShares}/
          {plusSharingLinkGenerationAmount}&nbsp;
        </span>
      )}
      {translate('blickPlus.linkSharing.title')}
    </StyledTitle>
  )
}

export default Title
